import { useMemo, useRef } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';

// getContext is a callback, not a value, because callers build it from the formState they
// destructure out of the useForm call this resolver is passed to — reading it eagerly there
// throws on the temporal dead zone.
export const useYupValidationResolver = (validationSchema, getContext) => {
    const resolve = useMemo(() => yupResolver(validationSchema), [validationSchema]);
    const latestGetContext = useRef(getContext);
    latestGetContext.current = getContext;

    return useMemo(
        () => (values, context, options) =>
            resolve(values, latestGetContext.current ? latestGetContext.current() : context, options),
        [resolve],
    );
};
